import {ILanguage} from '@components/select-language';

export const environment = {
  production: false,
  authority: 'https://masofa.6grain.uz/api',
  audience: 'https://masofa.6grain.uz/',
  gateway: 'https://masofa.6grain.uz/api',
  downloadReport: 'https://umapi-uploads.uz.6grain.com',
  databaseName: 'uz_browser_db',
  mapDownloadUrl: '/api/admin/download/maps/{date}/{type}.{format}',
  baseUrl: 'https://masofa.6grain.uz',
  moduleUrls: {
    menu: '/',
    weather: '/',
    notif: '/',
    soil: '/',
    'uav-dat': '/',
    satellite: '/',
    map: '/',
    'crop-monitoring': '/crop-monitoring',
    'crop-ident': '/',
    'field-pass': '/',
    'electronic-field-map': '/',
    reports: '/',
    dictionaries: '/dictionaries',
    admin: '/',
    books: '/',
    settings: '/',
    users: '/',
    foremans: '/',
  },
  api: 'https://masofa.6grain.uz/api',

  apiV2: '/api',
  apiCustomObjects: {},
  apiClient: {
    baseUrl: '/api',
    timeout: 30000,
    withCredentials: false,
  },
  versionApi: {
    backendUrl: 'https://masofa.6grain.uz/api/version'
  },
  map: {
    lat: 41.3,
    lng: 69.2667,
    center: {
      lat:41.38,
      lng: 64.59,
    },
    zoom:6
  },
  mapLayers: {
    plan: {
      name: 'Plan',
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '© OpenStreetMap contributors',
    },
    satellite: {
      name: 'Satellite',
      url: 'https://mt{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
      subdomains: ['0', '1', '2', '3'],
      attribution: '© Google',
    },
    google: {
      name: 'Satellite',
      url: 'https://mt{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
      subdomains: ['0', '1', '2', '3'],
      attribution: '© Google',
    },
    sentinel: {
      name: 'Sentinel',
      url: 'https://maps.heigit.org/openmapsurfer/tiles/EOX_S2cloudless_3857/{z}/{x}/{y}.jpg',
      attribution: '© ESA/Copernicus',
    },
    landsat: {
      name: 'Landsat',
      url: 'https://landsat.usgs.gov/arcgis/rest/services/Landsat_8_OLI_TIRS_C1/ImageServer/tile/{z}/{y}/{x}',
      attribution: '© USGS/NASA Landsat',
    },
  },
  defaultMapLayer: 'Plan',
  // Supported languages for LocalizationString fields in dictionaries
  supportedLanguages: ['uz-Latn-UZ', 'en-US', 'ru-RU'] as string[],
  trustedHosts: ['test.agropro.uz'] as string[],

  showAlertLevel:{
    Success: true,
    Info: true,
    Warning: true,
    Error: true,
  },

  assets:'/assets/',
  client: 'masofa',
  logoUrl: '/assets/icons/main/light/ico-logo.svg',
  appName: 'Masofa',
  logoScale:"1",

  defaultLang: 'uz-Latn-UZ',

  country:"Uzbekistan",
  langs: [
    {label: "O'zbek", value: 'uz-Latn-UZ', flag: 'uz-latn.png', iso: 'uz'},
    {label: 'English', value: 'en-US', flag: 'en-us.png', iso: 'en'},
    {label: 'Русский', value: 'ru-RU', flag: 'ru-ru.png', iso: 'ru'},
  ] as ILanguage[]



};
